import { inject } from '@angular/core';

import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { PaymentsApiService } from './../api/payments.api.sevice';

export class CustomTranslateLoaderService implements TranslateLoader {
    cashierType: string = '';
    paymentsApiService = inject(PaymentsApiService);

    constructor(cashierType: string) {
        this.cashierType = cashierType;
    }

    getTranslation(_langCountry: string): Observable<any> {
        return this.getContent();
    }

    getContent(): Observable<{ [key: string]: string }> {
        return this.paymentsApiService.get(`PaymentsApi/content?cashierType=${this.cashierType}`);
    }
}

export function createMainCashierTranslateLoader(): CustomTranslateLoaderService {
    return new CustomTranslateLoaderService('MainCashier');
}

export function createBetSlipQdTranslateLoader(): CustomTranslateLoaderService {
    return new CustomTranslateLoaderService('BetSlipQD');
}

export function createQuickDepositTranslateLoader(): CustomTranslateLoaderService {
    return new CustomTranslateLoaderService('QuickDeposit');
}
